"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateAuthUrl = void 0;
var _constants = require("../constants");
const generateAuthUrl = ({
  codeChallenge,
  identityUrl,
  tenant
}) => {
  // Quick hack for identityUrl until it's fixed on FP, sometimes it contains url {tenant}.online.ori which is wrong.
  const fixedIdentityUrl = identityUrl.includes('online.ori') ? 'https://identity-we.oriflame.com' : identityUrl;
  const url = new URL(fixedIdentityUrl);
  url.pathname = '/connect/authorize';
  url.searchParams.append('scope', 'all');
  url.searchParams.append('prompt', 'none');
  url.searchParams.append('client_id', 'GenesysWebMessenger');
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('code_challenge_method', `S256`);
  url.searchParams.append('acr_values', `tenant:${tenant}`);
  url.searchParams.append('code_challenge', codeChallenge);
  url.searchParams.append('redirect_uri', _constants.REDIRECT_URI);
  return url.toString();
};
exports.generateAuthUrl = generateAuthUrl;